import {of} from 'rxjs';
import {map, switchMap, catchError} from 'rxjs/operators';
import {ofType} from 'redux-observable';

import Http from '../../http/http';

import * as SearchActions from '../search/search.action';
import * as FavouriteActions from './favourite.action';
const FAV_URL = '/api/search/favourites';

export const fetch = action$ => {
  return action$.pipe(
    ofType(FavouriteActions.FAVOURITES_FETCH_INITIATED),
    switchMap(() =>
      Http.get(FAV_URL).pipe(
        map(response => FavouriteActions.favouriteFetchSuccess(response)),
        catchError(error => of(FavouriteActions.favouriteFetchFailed(error)))
      )
    )
  );
};

export const audit = action$ =>
  action$.pipe(
    ofType(SearchActions.SEARCH_SUCCESS),
    map(({payload}) => FavouriteActions.audit(payload.query))
  );

export const save = action$ =>
  action$.pipe(
    ofType(FavouriteActions.FAVOURITE_ADDED),
    switchMap(({payload}) =>
      Http.post(FAV_URL, {name: payload.name, search: payload.search}).pipe(
        map(response => FavouriteActions.favouriteAddSuccess(response)),
        catchError(error => of(FavouriteActions.favouriteAddFailed(error)))
      )
    )
  );

export const update = action$ =>
  action$.pipe(
    ofType(FavouriteActions.FAVOURITE_UPDATED),
    switchMap(({payload}) =>
      Http.put(`${FAV_URL}/${payload.id}`, payload).pipe(
        map(response => FavouriteActions.favouriteUpdateSuccess(response)),
        catchError(error => of(FavouriteActions.favouriteUpdateFailed(error)))
      )
    )
  );

export const remove = action$ =>
  action$.pipe(
    ofType(FavouriteActions.FAVOURITE_REMOVED),
    switchMap(({payload}) =>
      Http.delete(`${FAV_URL}/${payload.id}`).pipe(
        map(response => FavouriteActions.favouriteRemoveSuccess(response)),
        catchError(error => of(FavouriteActions.favouriteRemoveFailed(error)))
      )
    )
  );

export const restore = action$ =>
  action$.pipe(
    ofType(FavouriteActions.FAVOURITE_RESTORE),
    switchMap(({payload}) =>
      Http.patch(FAV_URL, [{name: 'restore', id: payload}]).pipe(
        map(response => FavouriteActions.favouriteRestoreSuccess(response)),
        catchError(error => of(FavouriteActions.favouriteRestoreFailed(error)))
      )
    )
  );
